import { reservationAction, getType } from '../../actions';

const initialState = {
    loading: true,
    month: "",
    branchID: 0,
    listRoom: {},
    listNumberRoom: [],
    listShowDate: [],
    listReservation: [],
    listCancel: [],
    listWaiting: [],
    listGuestFlow: [],
    listCompanyFlow: [],
    fristLoad: false,
    log: []
}

const reservationReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(reservationAction.fillRsvtData): {
            const { schedule, listReservation, listWaiting, listCancel, turnLoadingRoom} = action.payload;
            return {
                ...schedule,
                listReservation: listReservation,
                listWaiting: listWaiting,
                listCancel: listCancel,
                turnLoadingRoom,
                loading: false
            };
        }
        // case getType(reservationAction.fillListWaitingCancel): {
        //     const { listNeedFill, listFill } = action.payload;

        //     let newListNeedFill = {...state[listNeedFill]};
        //     const listBookingIdOnListNeedFill = Object.keys(newListNeedFill);
            
        //     Object.keys(listFill).forEach(booking_id => {
        //         if(!listBookingIdOnListNeedFill.includes(booking_id)) {
        //         //    newListNeedFill[""+item._id] = "";
        //             newListNeedFill[""+booking_id] = listFill[booking_id];
        //         }
        //     })

        //     //let newListNeedFill = new Map(Object.entries(state[listNeedFill]));

        //     // listFill.forEach(item => {
        //     //     if (!newListNeedFill.has(item._id)) {
        //     //         newListNeedFill.set(item._id, item); // luôn nằm cuối
        //     //     }
        //     // });

        //     if(listNeedFill === "listWaiting") {
        //        return {
        //         ...state,
        //         listWaiting: newListNeedFill
        //        }
        //     } else {
        //        return {
        //         ...state,
        //         listCancel: newListNeedFill
        //        } 
        //     }

        // }
        // case getType(reservationAction.fillListCancelList): {
        //     const {  realtimeCancelListID, realtimeCancel} = action.payload;
        //     let newListCancel = {...state.listCancel};

        //     let listIdBookingCancelCheck = [];

        //     if(Object.keys(state.listCancel).length > 0) {
        //          Object.values(state.listCancel).forEach(item => {
        //             let booking_id = "";

        //             for (const romData of item) {
        //                 if (romData !=="") {
        //                     booking_id = romData.id;
        //                     break;
        //                 }
        //             }
        //             listIdBookingCancelCheck.push(booking_id)
        //         });

        //         realtimeCancelListID.forEach(id=> {
        //             if(!listIdBookingCancelCheck.includes(id)) {
        //                 newListCancel[id] = realtimeCancel[id];
        //             }
        //         })

        //    } else {
        //      realtimeCancelListID.forEach(id => {
        //         newListCancel.push(realtimeCancel[id])
        //      })
        //    }

        //     return {
        //         ...state,
        //         listCancel: newListCancel,
        //     }
        // }
        // case getType(reservationAction.fillListWaitingList): {
        //     const {  realtimeWaiting } = action.payload;
        //     let newListWaiting = {...state.listWaiting};
            
        //     if(Object.keys(newListWaiting).length > 0) {
        //         Object.values(realtimeWaiting).forEach(item => {
        //             const count = Object.keys(newListWaiting);
        //             newListWaiting[count] = "";
        //             newListWaiting[count] = item;
        //         })
        //     } else { newListWaiting = realtimeWaiting }

        //     return {
        //         ...state,
        //         listWaiting: newListWaiting,
        //     } 
        // }
        // case getType(reservationAction.redoListWatingCancel): {
        //     const { list, changeId } = action.payload;
        //     const newListCancel =  {...state[list]};
        //     if( changeId in newListCancel ) delete newListCancel[changeId];
            
        //     return {
        //         ...state,
        //         listCancel: newListCancel
        //     };
        // }
        case getType(reservationAction.resetRsvtData): {
            return {
                loading: true,
                month: "",
                branchID: 0,
                listRoom: {},
                listNumberRoom: [],
                listShowDate: [],
                listReservation: [],
                turnLoadingRoom: {},
                listCancel: [],
                listWaiting: [],
                listGuestFlow: [],
                listCompanyFlow: [],
                log: []
            };
        }
        case getType(reservationAction.checkRealtime): { 
            const { room, changeType, booking_id, data } = action.payload;
            const newData = {...state.listReservation};
            const newListCancel = {...state.listCancel};
            const newListWaiting = {...state.listWaiting};

            if(changeType === "delete") {
                newData[room] = newData[room].map(item => {
                    if(Array.isArray(item)) {
                        return item.filter(subItem => subItem.booking_id !== booking_id);
                    } else {
                       if(item.booking_id === booking_id) {
                           return "";
                       } else return item
                    }
                });
              //  delete newData[room][dataChange.date];
            } else if(changeType === "update") {
                //            nextMonthRealtime: [],
                          //  dateThisMonth : getTodayMonth(),
                         //   dataNextMonth: getNextMonth()

                function checkRealtimeByMonth(listRoomNeedCheckRealtime, monthRealtime, realtimeWaiting, realtimeCancel, realtimeRedo) {
                    // console.log("vo here")
                    // console.log("listRoomNeedCheckRealtime", listRoomNeedCheckRealtime)
                    // console.log("monthRealtime", monthRealtime)
                    const safeListRoomNeedCheckRealtime = Array.isArray(listRoomNeedCheckRealtime) ? listRoomNeedCheckRealtime : [];
                    const safeMonthRealtime = monthRealtime && typeof monthRealtime === 'object' ? monthRealtime : {};
                    const safeRealtimeWaiting = realtimeWaiting && typeof realtimeWaiting === 'object' ? realtimeWaiting : {};
                    const safeRealtimeCancel = realtimeCancel && typeof realtimeCancel === 'object' ? realtimeCancel : {};

                    if(safeListRoomNeedCheckRealtime.length > 0 && Object.keys(safeMonthRealtime).length > 0) {
                        safeListRoomNeedCheckRealtime.forEach(room => {
                            newData[room] = safeMonthRealtime[room]
                        });
                    };

                     // check Waiting List
                    if(Object.keys(safeRealtimeWaiting).length > 0) {
                        const listIdOnListWaiting = Object.keys(state.listWaiting);
                        Object.keys(safeRealtimeWaiting).forEach(id => {
                            if(listIdOnListWaiting.includes(id)) {
                            } else newListWaiting[id] = safeRealtimeWaiting[id];
                        });
                    };

                    // check Cancel List
                    if(Object.keys(safeRealtimeCancel).length > 0) {
                        const listIdOnListCancel = Object.keys(state.listCancel);
                        Object.keys(safeRealtimeCancel).forEach(id => {
                            if(listIdOnListCancel.includes(id)) {
                            } else newListCancel[id] = safeRealtimeCancel[id];
                        });
                    }

                    // check Redo List
                    if(realtimeRedo !== "") {
                        if(realtimeRedo.type === "listCancel") {
                            if(Object.keys(newListCancel).includes(realtimeRedo.redoId)) {
                                   delete newListCancel[realtimeRedo.redoId];
                            }
                        } else {
                            if(Object.keys(newListWaiting).includes(realtimeRedo.redoId)) {
                                delete newListWaiting[realtimeRedo.redoId];
                            }
                        }
                    }
                }

                if(data.dateThisMonth === state.month) {
                    checkRealtimeByMonth(
                        data.thisMonthListRoomNeedCheckRealtime, 
                        data.thisMonthRealtime, 
                        data.thisMonthRealtimeWaiting, 
                        data.thisMonthRealtimeCancel, 
                        data.thisMonthRealtimeRedo
                    );
                } else if(data.dataNextMonth === state.month) {
                    checkRealtimeByMonth(
                        data.nextMonthListRoomNeedCheckRealtime, 
                        data.nextMonthRealtime, 
                        data.nextMonthRealtimeWaiting, 
                        data.nextMonthRealtimeCancel, 
                        data.nextMonthRealtimeRedo
                    );
                } else {
                    checkRealtimeByMonth(
                        data.otherMonthListRoomNeedCheckRealtime, 
                        data.otherMonthRealtime, 
                        data.otherMonthRealtimeWaiting, 
                        data.otherMonthRealtimeCancel, 
                        data.otherMonthRealtimeRedo
                    );
                }
            }

            return {
                ...state,
                listReservation: newData,
                listCancel: newListCancel,
                listWaiting: newListWaiting
            };
        }
        
        default: return state;
    }
}

export default reservationReducer;
